import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import { FaMinimize, FaMaximize } from 'react-icons/fa6'
import defaultTexts from '../../../texts/texts'
import { isBillingAvailable } from '../_helpers/billing'
import ConfigBillingServiceItem from './ConfigBillingServiceItem'

const ConfigBillingServices = (props) => {
  const {
    supportedServiceConfigs,
    selectedBackendServices,
    backendUserData,
    setBackendUserData,
    getRegionConfig,
    backendIsIdentityProviderSelected,
    billingServicesConfigurable,
    errors,
    setErrors,
    submitted,
    validateFormFields,
    appCredentialSecret,
    setAppCredentialSecret,
  } = props
  const theme = useTheme()

  const [filteredSelectedBackendServices, setFilteredSelectedBackendServices] = useState([])
  const [expanded, setExpanded] = useState(true)
  const [expandedPanel, setExpandedPanel] = useState('identity_keystone')
  
  const wrapperStyle = {
    background: 'white',
    borderRadius: '50px 20px 20px 20px',
    boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.25)',
    marginBottom: '40px',
  }

  const headStyle = {
    width: '100%',
    height: '60px',
  }

  const bodyStyle = {
    padding: '20px',
  }

  const labelStyle = {
    height: '60px',
    background: theme.palette.oxfordBlue,
    color: 'white',
    fontSize: '20px',
    fontWeight: '500',
    borderRadius: '50px 0px',
    padding: '0px 40px',    
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const handleChangeExpandedPanel = (panel) => (event, newExpanded) => {
    setExpandedPanel(newExpanded ? panel : false)
  }

  useEffect(() => {
    setFilteredSelectedBackendServices(selectedBackendServices.filter(item => isBillingAvailable(item.service, supportedServiceConfigs)))
  }, [selectedBackendServices, supportedServiceConfigs])

  return (
    <Box sx={wrapperStyle}>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={headStyle}
      >
        <Box sx={labelStyle}>
          <Box>{defaultTexts.openStackServices}</Box>
        </Box>
        <Box sx={{ paddingRight: '10px ' }}>
          {
            expanded ?
            <IconButton onClick={() => setExpanded(false)}>
              <FaMinimize color={theme.palette.greenSheen} />
            </IconButton> :
            <IconButton onClick={() => setExpanded(true)}>
              <FaMaximize color={theme.palette.greenSheen} />
            </IconButton>
          }
        </Box>
      </Stack>

      {
        expanded &&
        <Box sx={bodyStyle}>
          {
            filteredSelectedBackendServices.map((item, index) => (
              <ConfigBillingServiceItem
                key={index}
                {...item}
                expandedPanel={expandedPanel}
                handleChangeExpandedPanel={handleChangeExpandedPanel}
                backendUserData={backendUserData}
                setBackendUserData={setBackendUserData}
                getRegionConfig={getRegionConfig}
                backendIsIdentityProviderSelected={backendIsIdentityProviderSelected}
                billingServicesConfigurable={billingServicesConfigurable}
                errors={errors}
                setErrors={setErrors}
                submitted={submitted}
                validateFormFields={validateFormFields}
                appCredentialSecret={appCredentialSecret}
                setAppCredentialSecret={setAppCredentialSecret}
              />
            ))
          }
        </Box>
      }
    </Box>
  )
}

export default ConfigBillingServices